<div modalHeader style="min-height: 1px">
  <div *ngIf="options.title" class="modal-header">
    <h2 class="modal-title font-weight-bold" [innerText]="options.title"></h2>
    <button type="button" class="close" aria-label="Close" tabindex="-1" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>

<div modalContent class="modal-body">
  <p [innerHtml]="options.content" class="mb-0"></p>

  <div class="d-flex flex-row align-items-center justify-content-start gap-1" *ngIf="options.showCheckBox">
    <input type="checkbox" [(ngModel)]="checkboxStatus">
    <p class="mb-0" [innerText]="options.checkboxContent"></p>
  </div>
</div>

<div modalFooter class="modal-footer">
  <div class="d-flex flex-row justify-content-between w-100">
    <button type="button" class="btn btn-info w-100 mr-2" [innerText]="options.confirmBtnText || 'Confirm'" [disabled]="confirmBtnDisabled" (click)="confirm()"></button>
    <button type="button" class="btn btn-danger w-100" [innerText]="options.closeBtnText || 'Close'" (click)="close()"></button>
  </div>
</div>
